export enum DeadlineType {
  None,
  WorkingDays,
  Days,
  Date,
}
